import { PropertySelectorDialogComponent } from './../../../dialogs/property-selector-dialog/property-selector-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Commission } from './../../../models/commission.model';
import { PropertiesService } from './../../../services/properties.service';
import { ErrorResponse } from './../../../models/error.model';
import { UtilsService } from './../../../services/utils.service';
import { QuotesService } from './../../../services/quotes.service';
import { QuotationService, Quote, QuoteType } from './../../../models/quote.model';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Property } from './../../../models/property.model';
import { SelectOption } from './../../../models/select-option.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Category } from '../../generics/data-printer/data-printer.component';
import { User } from '../../../models/user.model';
import { AuthService } from '../../../services/auth.service';
import { Broker } from 'src/app/models/broker.model';
import { BrokerSelectorDialogComponent } from 'src/app/dialogs/broker-selector-dialog/broker-selector-dialog.component';
import { Router } from '@angular/router';
import { ViewEncapsulation } from '@angular/core';
import { TiposFianzaService } from '../../../services/tipos-fianza.service';
import { ZonasService } from '../../../services/zonas.service';
import { TiposDescuentoService } from '../../../services/tipos-descuento.service';
import { TipoFianza, ClaveFianza, TipoProducto } from '../../../models/tipo-fianza.model';
import { TipoDescuento } from '../../../models/tipo-descuento.model';
import { Zona } from '../../../models/zona.model';
import { ComercialesService } from '../../../services/comerciales.service';
import { Comercial } from '../../../models/comercial.model';

export const SERVICIOS_POR_CLAVE: Record<ClaveFianza, string[]> = {
    'basica':        ['ALQUILER', 'EXPENSAS'],
    'con_abl':       ['ALQUILER', 'EXPENSAS', 'ABL'],
    'con_servicios': ['ALQUILER', 'EXPENSAS', 'ABL', 'LUZ', 'AGUA', 'GAS'],
    'completa':      ['ALQUILER', 'EXPENSAS', 'ABL', 'LUZ', 'AGUA', 'GAS', 'IKE', 'ADMINISTRACION'],
};

@Component({
    selector: 'app-new-quote',
    templateUrl: './new-quote.component.html',
    styleUrls: ['./new-quote.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NewQuoteComponent implements OnInit {

    quoteFG = new UntypedFormGroup({
        propiedad:            new UntypedFormControl(undefined),
        tipo:                 new UntypedFormControl('VIVIENDA', [Validators.required]),
        idZona:               new UntypedFormControl(null),
        idTipoFianza:         new UntypedFormControl(null, [Validators.required]),
        monedaAlquiler:       new UntypedFormControl('ARS', [Validators.required]),
        alquiler:             new UntypedFormControl('', [Validators.required]),
        tipoCambio:           new UntypedFormControl(''),
        monedaExpensas:       new UntypedFormControl('ARS', [Validators.required]),
        expensas:             new UntypedFormControl('', [Validators.required]),
        tipoActualizacion:       new UntypedFormControl('MANUAL', [Validators.required]),
        tipoActualizacionCustom: new UntypedFormControl(''),
        duracion:                new UntypedFormControl('', [Validators.required, Validators.min(1), Validators.max(120)]),
        actualizacion:        new UntypedFormControl(''),
        periodoActualizacion: new UntypedFormControl(''),
        idTipoDescuento:      new UntypedFormControl(null),
        porcentajeRenovacion: new UntypedFormControl(''),
        idComercial:          new UntypedFormControl(null),
        nombre:               new UntypedFormControl(''),
        apellido:             new UntypedFormControl(''),
        dniCuit:              new UntypedFormControl(''),
        perfilAprobado:       new UntypedFormControl(false),
        incluir12Cuotas:      new UntypedFormControl(false),
    });

    quoteTypes: SelectOption[] = [
        { codigo: 'COMERCIAL', descripcion: 'Comercio' },
        { codigo: 'VIVIENDA',  descripcion: 'Vivienda' },
    ];

    updatePeriods: SelectOption[] = [
        { codigo: 1,  descripcion: 'Mensual'      },
        { codigo: 2,  descripcion: 'Bimestral'    },
        { codigo: 3,  descripcion: 'Trimestral'   },
        { codigo: 4,  descripcion: 'Cuatrimestral'},
        { codigo: 6,  descripcion: 'Semestral'    },
        { codigo: 12, descripcion: 'Anual'        },
    ];

    monedas: SelectOption[] = [
        { codigo: 'ARS', descripcion: 'ARS' },
        { codigo: 'USD', descripcion: 'USD' },
    ];

    tipoActualizacionOptions: SelectOption[] = [
        { codigo: 'IPC',    descripcion: 'IPC'  },
        { codigo: 'ICL',    descripcion: 'ICL'  },
        { codigo: 'MANUAL', descripcion: 'Fijo' },
        { codigo: 'OTRO',   descripcion: 'Otro' },
    ];

    zonas: Zona[] = [];
    tiposFianza: TipoFianza[] = [];
    tiposDescuento: TipoDescuento[] = [];
    tiposDescuentoFiltrados: TipoDescuento[] = [];
    selectedTipoFianza: TipoFianza | null = null;
    selectedTipoDescuento: TipoDescuento | null = null;
    comerciales: Comercial[] = [];

    get mostrarInputCustom(): boolean { return this.quoteFG.value.tipoActualizacion === 'OTRO'; }

    broker?: Broker;
    serviceCategories: Category[] = [];
    quoteResult: Quote;
    commission: Commission;

    @ViewChild('stepper')
    stepper: MatStepper;

    user?: User;

    constructor(
        private quotesService: QuotesService,
        private router: Router,
        private propertiesService: PropertiesService,
        public utilsService: UtilsService,
        private authService: AuthService,
        private dialog: MatDialog,
        private tiposFianzaService: TiposFianzaService,
        private zonasService: ZonasService,
        private tiposDescuentoService: TiposDescuentoService,
        private comercialesService: ComercialesService,
    ) { }

    ngOnInit(): void {
        this.user = this.authService.getUser();
        if (this.user.tipo === 'AGENTE' && this.user.agente) {
            this.broker = this.user.agente;
        }
        this.loadZonas();
        this.loadTiposDescuento();
        this.loadTiposFianza('VIVIENDA', null);
        this.loadComerciales();
        this.preseleccionarMiComercial();

        this.quoteFG.controls.tipo.valueChanges.subscribe((tipo: QuoteType) => {
            this.quoteFG.controls.actualizacion.setValue('');
            this.quoteFG.controls.periodoActualizacion.setValue('');
            this.resetFianzaSelection();
            this.loadTiposFianza(tipo, this.quoteFG.value.idZona);
        });
    }

    private loadComerciales(): void {
        this.comercialesService.getComerciales(0, 100, [], { 'ocultar-inactivos': 'true' }).subscribe({
            next: response => this.comerciales = response.body || [],
            error: () => this.comerciales = []
        });
    }

    private preseleccionarMiComercial(): void {
        this.comercialesService.getMiComercial().subscribe({
            next: response => {
                if (response.body?.id) this.quoteFG.controls.idComercial.setValue(response.body.id);
            },
            error: () => { /* el usuario no tiene comercial asignado, queda sin preseleccionar */ }
        });
    }

    private loadZonas(): void {
        this.zonasService.getZonas(0, 100, [], { 'ocultar-inactivos': 'true' }).subscribe({
            next: response => this.zonas = response.body || [],
            error: () => this.zonas = []
        });
    }

    private loadTiposDescuento(): void {
        this.tiposDescuentoService.getTiposDescuento(0, 100, [], { 'ocultar-inactivos': 'true' }).subscribe({
            next: response => {
                this.tiposDescuento = response.body || [];
                this.tiposDescuentoFiltrados = [...this.tiposDescuento];
            },
            error: () => { this.tiposDescuento = []; this.tiposDescuentoFiltrados = []; }
        });
    }

    private loadTiposFianza(tipo: QuoteType, idZona: number | null): void {
        const tipoProducto = tipo as TipoProducto;
        this.tiposFianzaService.getTiposFianza(0, 100, [], tipoProducto, true).subscribe({
            next: response => {
                const all = response.body || [];
                if (!idZona) {
                    this.tiposFianza = all.filter(f => !f.idZona);
                } else {
                    // Herencia de zona: prefer override, fallback to Default por clave
                    const claves = [...new Set(all.map(f => f.clave))];
                    this.tiposFianza = claves
                        .map(clave =>
                            all.find(f => f.clave === clave && f.idZona === idZona) ||
                            all.find(f => f.clave === clave && !f.idZona)
                        )
                        .filter((f): f is TipoFianza => !!f);
                }
            },
            error: () => this.tiposFianza = []
        });
    }

    onZonaChange(idZona: number | null): void {
        this.resetFianzaSelection();
        this.loadTiposFianza(this.quoteFG.value.tipo, idZona);
    }

    onFianzaChange(idFianza: number | null): void {
        this.selectedTipoFianza = idFianza
            ? (this.tiposFianza.find(f => f.id === idFianza) ?? null)
            : null;

        if (!this.selectedTipoFianza) return;

        // Actualizar validadores de plazo según la fianza seleccionada
        const min = this.selectedTipoFianza.plazoMinMeses;
        const max = this.selectedTipoFianza.plazoMaxMeses;
        this.quoteFG.controls.duracion.setValidators([Validators.required, Validators.min(min), Validators.max(max)]);
        const currentDuracion = this.quoteFG.value.duracion;
        if (currentDuracion && (currentDuracion < min || currentDuracion > max)) {
            this.quoteFG.controls.duracion.setValue('');
        }
        this.quoteFG.controls.duracion.updateValueAndValidity();

        // Filtrar tipos de descuento aplicables a esta fianza
        const ids = this.selectedTipoFianza.idsTipoDescuento;
        this.tiposDescuentoFiltrados = ids?.length
            ? this.tiposDescuento.filter(td => ids.includes(td.id!))
            : [...this.tiposDescuento];

        // Limpiar tipo de descuento si ya no está disponible
        const currentDescuentoId = this.quoteFG.value.idTipoDescuento;
        if (currentDescuentoId && !this.tiposDescuentoFiltrados.find(td => td.id === currentDescuentoId)) {
            this.quoteFG.controls.idTipoDescuento.setValue(null);
            this.selectedTipoDescuento = null;
            this.quoteFG.controls.porcentajeRenovacion.clearValidators();
            this.quoteFG.controls.porcentajeRenovacion.setValue('');
            this.quoteFG.controls.porcentajeRenovacion.updateValueAndValidity();
        }
    }

    onTipoDescuentoChange(idTipoDescuento: number | null): void {
        this.selectedTipoDescuento = idTipoDescuento
            ? (this.tiposDescuentoFiltrados.find(td => td.id === idTipoDescuento) ?? null)
            : null;

        if (this.selectedTipoDescuento) {
            const topeMax = this.selectedTipoDescuento.tope ?? 100;
            this.quoteFG.controls.porcentajeRenovacion.setValidators([
                Validators.required, Validators.min(0), Validators.max(topeMax)
            ]);
        } else {
            this.quoteFG.controls.porcentajeRenovacion.clearValidators();
            this.quoteFG.controls.porcentajeRenovacion.setValue('');
        }
        this.quoteFG.controls.porcentajeRenovacion.updateValueAndValidity();
    }

    get mostrarPorcentajeRenovacion(): boolean {
        return !!this.selectedTipoDescuento;
    }

    get formIsReady(): boolean {
        // OFICINA puede cotizar sin elegir agente todavía: se asigna después del pago
        // (ver "Asignar agente" en warranty-details). CORPORATIVO sigue necesitándolo.
        const brokerRequired = this.user?.tipo === 'CORPORATIVO';
        return this.quoteFG.valid && !!this.selectedTipoFianza && (!brokerRequired || !!this.broker);
    }

    get mostrarTipoCambio(): boolean {
        return this.quoteFG.value.monedaAlquiler === 'USD' || this.quoteFG.value.monedaExpensas === 'USD';
    }

    get plazoHint(): string {
        if (!this.selectedTipoFianza) return '1 – 120 meses';
        return `${this.selectedTipoFianza.plazoMinMeses} – ${this.selectedTipoFianza.plazoMaxMeses} meses`;
    }

    get selectedFianzaServicios(): string[] {
        if (!this.selectedTipoFianza) return [];
        return SERVICIOS_POR_CLAVE[this.selectedTipoFianza.clave] || [];
    }

    private resetFianzaSelection(): void {
        this.selectedTipoFianza = null;
        this.selectedTipoDescuento = null;
        this.tiposFianza = [];
        this.tiposDescuentoFiltrados = [...this.tiposDescuento];
        this.quoteFG.controls.idTipoFianza.setValue(null);
        this.quoteFG.controls.idTipoDescuento.setValue(null);
        this.quoteFG.controls.porcentajeRenovacion.clearValidators();
        this.quoteFG.controls.porcentajeRenovacion.setValue('');
        this.quoteFG.controls.porcentajeRenovacion.updateValueAndValidity();
        this.quoteFG.controls.duracion.setValidators([Validators.required, Validators.min(1), Validators.max(120)]);
        this.quoteFG.controls.duracion.updateValueAndValidity();
    }

    getQuoteResult() {
        if (!this.quoteFG.valid || !this.selectedTipoFianza) return;

        const prop = this.quoteFG.value.propiedad as Property;
        const serviceCodes = SERVICIOS_POR_CLAVE[this.selectedTipoFianza.clave] || [];

        const descuentoComercial: number | undefined = this.selectedTipoDescuento
            ? this.quoteFG.value.porcentajeRenovacion
            : undefined;

        const quote: Quote = {
            // Si todavía no se eligió agente (OFICINA puede cotizar sin uno), la oficina
            // sale del usuario logueado; el agente se asigna después del pago.
            idOficina:            this.broker?.oficina?.id ?? this.user?.oficina?.id,
            idAgente:             this.broker?.id,
            tipo:                 this.quoteFG.value.tipo,
            tipoActualizacion:    this.quoteFG.value.tipoActualizacion === 'OTRO'
                                      ? this.quoteFG.value.tipoActualizacionCustom
                                      : this.quoteFG.value.tipoActualizacion,
            codigoMonedaAlquiler: this.quoteFG.value.monedaAlquiler,
            alquiler:             this.quoteFG.value.alquiler,
            codigoMonedaExpensas: this.quoteFG.value.monedaExpensas,
            expensas:             this.quoteFG.value.expensas,
            idPropiedad:          prop?.id,
            duracion:             this.quoteFG.value.duracion,
            servicios:            serviceCodes.map(codigo => ({ codigo })),
            idZona:               this.quoteFG.value.idZona ?? undefined,
            descuentoComercial,
            tipoCambio:           this.quoteFG.value.tipoCambio || undefined,
            idComercial:          this.quoteFG.value.idComercial ?? undefined,
            nombre:               this.quoteFG.value.nombre || undefined,
            apellido:             this.quoteFG.value.apellido || undefined,
            dniCuit:              this.quoteFG.value.dniCuit || undefined,
            perfilAprobado:       this.quoteFG.value.perfilAprobado ?? false,
            incluir12Cuotas:      this.quoteFG.value.incluir12Cuotas ?? false,
        };
        if (quote.tipo === 'COMERCIAL') {
            quote.actualizacion        = this.quoteFG.value.actualizacion;
            quote.periodoActualizacion = this.quoteFG.value.periodoActualizacion;
        }

        this.quotesService.newQuote(quote).subscribe(
            result => {
                this.quoteResult = result;
                this.serviceCategories = [this.mapServicesToCategory(result.servicios)];
                setTimeout(() => this.stepper.next());
            },
            (error: ErrorResponse) => this.utilsService.alert('Error al generar cotización', error.error?.descripcion)
        );

        this.updateCommission(quote.alquiler, quote.expensas, this.broker?.id, serviceCodes, quote.tipo);
    }

    mapServicesToCategory(services: QuotationService[]) {
        const servicesCategory: Category = { name: 'Servicios ', items: [] };
        services?.forEach(service => {
            servicesCategory.items.push({ value: service.nombre, alignment: 'center' });
        });
        return servicesCategory;
    }

    updateCommission(alquiler: number, expensas: number, idAgente: any, serviceCodes: string[], tipoCotizacion: QuoteType) {
        if (!idAgente) return;
        const servicios = serviceCodes.map(codigo => ({ codigo, nombre: '', topeMaximoDefault: 0, comision: 0 })) as any[];
        this.propertiesService.calculateCommission(alquiler, expensas, idAgente, servicios, tipoCotizacion, 'GARANTIA').subscribe(
            commission => this.commission = commission,
            (error: ErrorResponse) => this.utilsService.alert('Error al obtener comisión estimada', error.error?.descripcion)
        );
    }

    openSelectPropertyModal() {
        this.dialog.open(PropertySelectorDialogComponent, { data: { idAgente: this.broker?.id } }).afterClosed().subscribe({
            next: (property: Property | undefined) => {
                this.quoteFG.controls.propiedad.setValue(property);
                if (property) {
                    this.quoteFG.controls.tipo.setValue(
                        property.tipo !== 'AMBOS' ? property.tipo : 'VIVIENDA'
                    );
                    this.quoteFG.controls.alquiler.setValue(property.alquiler);
                    this.quoteFG.controls.expensas.setValue(property.expensas);
                    this.quoteFG.controls.actualizacion.setValue(property.actualizacion ?? '');
                    this.quoteFG.controls.periodoActualizacion.setValue(property.periodoActualizacion ?? '');
                }
            }
        });
    }

    openSelectBrokerModal() {
        this.dialog.open(BrokerSelectorDialogComponent).afterClosed().subscribe({
            next: (broker: Broker | undefined) => {
                if (broker) this.broker = broker;
            }
        });
    }

    resetForm() {
        this.quoteFG.setValue({
            propiedad:            null,
            tipo:                 'VIVIENDA',
            idZona:               null,
            idTipoFianza:         null,
            monedaAlquiler:       'ARS',
            alquiler:             '',
            tipoCambio:           '',
            monedaExpensas:       'ARS',
            expensas:             '',
            tipoActualizacion:       'MANUAL',
            tipoActualizacionCustom: '',
            duracion:                '',
            actualizacion:        '',
            periodoActualizacion: '',
            idTipoDescuento:      null,
            porcentajeRenovacion: '',
            idComercial:          null,
            nombre:               '',
            apellido:             '',
            dniCuit:              '',
            perfilAprobado:       false,
            incluir12Cuotas:      false,
        });
        this.selectedTipoFianza = null;
        this.selectedTipoDescuento = null;
        this.tiposDescuentoFiltrados = [...this.tiposDescuento];
        this.quoteFG.controls.duracion.setValidators([Validators.required, Validators.min(1), Validators.max(120)]);
        this.quoteFG.controls.duracion.updateValueAndValidity();
        this.loadTiposFianza('VIVIENDA', null);
        this.preseleccionarMiComercial();
    }

    validadDisponibilidadPropiedad(quoteResult: Quote) {
        if (!quoteResult.propiedad) {
            // La propiedad es opcional: se puede asociar más adelante, después del pago.
            this.router.navigate(['garantias', 'nueva'], { queryParams: { quoteId: quoteResult.id } });
            return;
        }
        this.propertiesService.isPropertyAvaiable(quoteResult.propiedad.id).subscribe({
            next: response => {
                if (!response) {
                    this.utilsService.alert('La propiedad ya se encuentra en una garantía activa', '');
                } else {
                    this.router.navigate(['garantias', 'nueva'], { queryParams: { quoteId: quoteResult.id } });
                }
            },
            error: (error: ErrorResponse) => this.utilsService.alert('Error al validar disponibilidad de la propiedad', error.error?.descripcion)
        });
    }
}
